import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://mhkmgratcfxxfhnzkdld.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1oa21ncmF0Y2Z4eGZobnprZGxkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE2NzQwNDAsImV4cCI6MjA2NzI1MDA0MH0.0aQSAzEFskV65Snb3lwNHb0dTAtPmB43BLfJp8sO9MM';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
    },
});